import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useError, useTokenRenewal } from 'hooks';
import { observer } from 'mobx-react-lite';
import { IResponseError } from 'models';
import { ErrorPage, Home } from 'pages';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';
import { userStore } from 'stores';

import { Template } from './components';
import { privateRoutes, publicRoutes } from './routes/routes';

const App = observer(() => {
	const { onErrorFn, contextHolder } = useError();
	useTokenRenewal();
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false
			}
		},
		queryCache: new QueryCache({
			onError: (error, query) => {
				onErrorFn(error as AxiosError<IResponseError>, query.meta?.errorMessage as string);
			}
		})
	});

	const routes = userStore.role ? privateRoutes(userStore.role) : publicRoutes;

	const router = createBrowserRouter([
		{
			path: '/',
			element: <Template />,
			errorElement: <ErrorPage />,
			children: [
				{
					path: '/',
					element: <Home />
				},
				...routes
			]
		}
	]);
	const handlers = useSwipeable({
		onSwipedDown: () => window.location.reload(),
		onSwipedRight: () => window.history.back(),
		delta: {
			down: 450,
			right: 250
		}
	});

	return (
		<QueryClientProvider client={queryClient}>
			<div {...handlers} className="app-container">
				<RouterProvider router={router} />
				{contextHolder}
			</div>
		</QueryClientProvider>
	);
});

export default App;